import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { EMBED } from 'constants/types';
import SimpleCarousel from 'components/SimpleCarousel';
import Call4Impact from 'components/Cards/Call4ImpactCard';
import ThemeTableCard from 'components/Cards/ThemeTableCard';
import { getPublicCallsForImpact } from 'modules/callForImpact/actions';
import { CardWithTablesGrid } from './styles';


function CardWithTables(props) {
  const {
    id, tableUrl, callUrl, embedId,
  } = props;

  const [call, setCall] = useState(null);

  useEffect(() => {
    getPublicCallsForImpact({ ids: id, embed_id: embedId })
      .then((response) => {
        if (response.length) {
          setCall(response[0]);
        }
      });
  }, []);

  const handleClickTable = (table) => {
    window.top.location.href = tableUrl.replace('*|tableId|*', table);
    // window.open(tableUrl.replace('*|tableId|*', table));
  };

  const handleClickCall = () => {
    window.top.location.href = callUrl.replace('*|callId|*', id);
  };

  const printTables = () => {
    if (!call.theme_tables.length) {
      return null;
    }

    return (
      <SimpleCarousel classesList='theme_table_card' showButtons>
        {_.map(call.theme_tables, think => (<ThemeTableCard key={think.id} data={think} row onClick={handleClickTable} />))}
      </SimpleCarousel>
    );
  };

  if (!call) {
    return null;
  }

  return (
    <CardWithTablesGrid>
      <div>
        <Call4Impact
          data={call}
          type={EMBED}
          planId={0}
          onClickStart={handleClickCall}
        />
      </div>
      <div className='tables_carousel'>{printTables()}</div>
    </CardWithTablesGrid>);
}

CardWithTables.propTypes = {
  id: PropTypes.number.isRequired,
  tableUrl: PropTypes.string.isRequired,
  callUrl: PropTypes.string.isRequired,
  embedId: PropTypes.number.isRequired,
};

export default CardWithTables;



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/CardWithTables/components/index.jsx